import { matchPath } from 'react-router';
import type { routeType } from 'src/utils/proptypes';

export const TITLE_SEPARATOR = ' | ';

/** The client route whose pattern matches `pathname`, if any. */
export function findRoute(routes: routeType[], pathname: string): routeType | undefined {
   return routes.find(route => !!route.path && !!matchPath(route.path, pathname));
}

/**
 * What document.title should become after the router lands on `route`
 * (WCAG 2.4.2). Returns null when the route owns its own title and the
 * router must leave it alone:
 *  - `seo`: the page renders <SEO>/<title>; React 19 hoists that into <head>
 *    and an imperative write here would fight it (the NPT-1072 regression).
 *  - `ssr` before any in-app navigation: Vike emitted a richer per-route
 *    +title.ts on the document load; it only goes stale once the SPA
 *    navigates away and back.
 */
export function resolveRouteTitle(route: routeType | undefined, navigated: boolean, siteName: string): string | null {
   if (!route?.title) return null;
   if (route.titleSource === 'seo') return null;
   if (route.titleSource === 'ssr' && !navigated) return null;
   return `${route.title}${TITLE_SEPARATOR}${siteName}`;
}
